import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { GenerationProvider } from './contexts/GenerationContext';
import { NowPlayingProvider } from './contexts/NowPlayingContext';
import { ReadingPreferencesProvider } from './contexts/ReadingPreferencesContext';
import { ReadingEventsProvider } from './contexts/ReadingEventsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <GenerationProvider>
          <ReadingPreferencesProvider>
            <NowPlayingProvider>
              <ReadingEventsProvider>
                <App />
              </ReadingEventsProvider>
            </NowPlayingProvider>
          </ReadingPreferencesProvider>
        </GenerationProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
